export const blockInvalidChar = e => ['.','e', 'E', '-','+','ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault();